import { useNavigate, useLocation } from "react-router-dom";
import { useNotification } from "../context/NotificationContext";
import { NotificationType } from "../enums/NotificationType";
import { useTranslation } from 'react-i18next';
import '../css/pages/error.css';

const ErrorPage = () => {
    const { showNotification } = useNotification();
    const navigate = useNavigate();
    const location = useLocation();
    const [t] = useTranslation('global');
    
    const getErrorMessage = (errorMessage) => {
        if (errorMessage?.includes("Max user count limit reached")) {
            return t('maxUserLimit');
        } else if (errorMessage?.includes("is not Active")) {
            return t('inactiveUser');
        }
        return errorMessage || "Vyskytla sa neočakávaná chyba.";
    };

    const errorMessage = getErrorMessage(location.state?.errorMessage);

    return (
        <>
        <div className='msger-logo'>
            <div className="premiumTitle-wizard">
            </div>
        </div>
        <div className="error-page">


            <div className="error-content">
                <h1>{t('ooopsError')}</h1>
                <p>{errorMessage}</p>
                <p>{t('contactAdmin')}</p>
                <button className="submit-button" onClick={() => navigate("/login")}>{t('backToLogin')}</button>
            </div>
        </div>
        </>
        
    )
}

export default ErrorPage;